/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable no-param-reassign */
/* eslint-disable react/forbid-prop-types */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import AppLink from '../../shared/components/app-link/AppLink';
import {
  DATE_MONTH_YEAR_FORMAT,
  NAVIGATION_ROUTES,
} from '../../shared/constants/Constants';
import AppTextInput from '../../shared/components/app-text-input/AppTextInput';
import { debounce } from '../../api/apiUtils';
import { formatDate, getNewDate } from '../../shared/helper-utils/appUtils';

function FlightHoldQueueList({ flightHoldQueues }) {
  const [transactionsList, setTransactionsList] = useState([]);
  const [searchText, setSearchText] = useState('');

  useEffect(() => {
    setTransactionsList(flightHoldQueues);
  }, [flightHoldQueues]);

  const getFlightTicket = (txid) => {
    let route = NAVIGATION_ROUTES.FLIGHT.FLIGHT_TICKET_PAGE;
    route = route.replace(':transactionId', txid);
    return route;
  };
  const setSearchResults = debounce((val) => {
    let data = [...flightHoldQueues];
    if (val !== '') {
      data = data.filter((o) =>
        Object.keys(o).some(
          (k) =>
            o[k] !== null &&
            o[k] !== undefined &&
            o[k].toString().toLowerCase().includes(val.toLowerCase()),
        ),
      );
    }
    setTransactionsList(data);
  }, 500);
  const handleSearch = (event) => {
    const { value } = event.target;
    setSearchText(value);
    setSearchResults(value);
  };
  return (
    <section className="flight-canx-list p-2 ">
      <div className="flight-canx-list_container p-2">
        <div>
          <div className="m-2 d-flex">
            <div style={{ width: '300px' }}>
              <AppTextInput
                value={searchText}
                label="search"
                onChange={handleSearch}
              />
            </div>
          </div>
        </div>
        <table>
          <thead>
            <tr>
              <th>Tx.Id</th>
              <th>Origin</th>
              <th>Destination</th>
              <th>Carrier</th>
              <th>BookingDate</th>
              <th>JDate</th>
              <th>Booking Status</th>
              <th>View Ticket</th>
            </tr>
          </thead>
          <tbody>
            {transactionsList.map((transaction) => (
              <tr key={transaction.Txid}>
                <td>{transaction.Txid}</td>
                <td>{transaction.Origin}</td>
                <td>{transaction.Destination}</td>
                <td>{transaction.Carrier}</td>
                <td>
                  {formatDate(
                    getNewDate(transaction.BookingDate.split(' ')[0]),
                    DATE_MONTH_YEAR_FORMAT,
                  )}{' '}
                  {transaction?.BookingDate?.split(' ')[1]}
                </td>
                <td>
                  {formatDate(
                    getNewDate(transaction.JDate),
                    DATE_MONTH_YEAR_FORMAT,
                  )}
                </td>
                <td>{transaction.BookingStatus}</td>
                <td>
                  <AppLink
                    linkText="View Ticket"
                    isLink
                    target="_blank"
                    href={getFlightTicket(transaction.Txid)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
FlightHoldQueueList.propTypes = {
  flightHoldQueues: PropTypes.array.isRequired,
};

export default FlightHoldQueueList;
